import base from './base'; // 导入接口域名列表
import axios from '@/utils/http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const order = {
  // 下单
  order(params) {
 console.log('>>> 新版order执行标记', Date.now());   // ← 新增标记
    const data = Object.assign(
        {
            userAgent: (typeof navigator !== 'undefined' && navigator.userAgent) || ''
            // userAgent: '测试'
        },
        params
    );
            console.log('测试UA', data)
    return axios.post(`${base.url}${base.path}/order`, data);
  },
  // 支付
  pay(params) {
    return axios.post(`${base.url}${base.path}/pay/unionOrder`, params);
  },
  // 支付
  yddPay(params) {
    return axios.post(`${base.url}${base.path}/jtbarcodePay/yddPay`, params);
  },
  // 数字货币支付
  szbWalletPay(params) {
    return axios.post(`${base.url}${base.path}/szbWalletPay/order`, params);
  },
  // 支付
  walletPay(params) {
    return axios.post(`${base.url}${base.path}/jtWalletPay/order`, params);
  },
  payTest(params) {
      return axios.post(`${base.url}${base.path}/pay/unionOrder2`, params);
  }
}

export default order;
